module.exports = __webpack_public_path__ + "static/media/aa17.eb9533ae.jpg";